import { render } from "./ThePreloader.vue?vue&type=template&id=242b7a3e&scoped=true"
import script from "./ThePreloader.vue?vue&type=script&lang=js"
export * from "./ThePreloader.vue?vue&type=script&lang=js"

import "./ThePreloader.vue?vue&type=style&index=0&id=242b7a3e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-242b7a3e"]])

export default __exports__